import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VerticalPaddingInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VerticalPaddingInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ padding, setPadding ] = useState<number>(project.encoder.overlayVerticalPadding);
  const debounce = 100;
  const min = 5;
  const max = 200;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = padding;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setPadding(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayVerticalPadding: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayVerticalPadding: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setPadding(project.encoder.overlayVerticalPadding);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayVerticalPadding]);

  return (
    <div className="vertical-padding-input">
      <div className="input-title">
        {t('producer.inputs.vertical-padding.title')}
        <Help
          title="Vertical Padding"
          text="Allows you to add space above and below the captions."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.vertical-padding.placeholder"
        value={padding.toString()}
        onChange={(value) => {setPadding(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.vertical-padding.footer')}</div>
    </div>
  );
};

export default React.memo(VerticalPaddingInput);
